/**
 * Notre histoire — apparition légère des étapes au défilement.
 */
(function () {
  'use strict';

  var section = document.querySelector('.notre-histoire');
  if (!section) return;

  var targets = section.querySelectorAll('.notre-histoire__item, .notre-histoire__cta-inner');
  if (!targets.length) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-visible');
    return;
  }

  if (!('IntersectionObserver' in window)) {
    for (var j = 0; j < targets.length; j++) targets[j].classList.add('is-visible');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var k = 0; k < entries.length; k++) {
        var entry = entries[k];
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }
  );

  for (var n = 0; n < targets.length; n++) observer.observe(targets[n]);
})();